import { useContext } from 'react';

import { Viewer, ViewerContext } from './ViewerContext';

/**
 * Shortcut utility to get optional viewer from current context.
 * Used in places where viewer may be nullable and needs manual assertion and checks (app roots mainly).
 *
 * @returns currently supplied viewer object from React context or null if it is not supplied / existing
 */
export function useOptionalViewer(): Viewer | null {
  return useContext(ViewerContext);
}
